import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/registrar',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Registrar',
          path: '',
          component: () => import('@/views/pages/UsuarioProdutor'),
        },
        {
          name: 'login',
          path: '/Login',
          component: () => import('@/views/pages/Login'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Principal',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Editar Perfil',
          path: '/editar-perfil',
          component: () => import('@/views/dashboard/forms/EditProfileForm'),
        },
        // {
        //   name: 'UsuarioProdutor',
        //   path: 'usuarioprodutor',
        //   component: () => import('@/views/pages/UsuarioProdutor'),
        // },
        {
          name: 'Entrega Leite',
          path: '/entrega-leite',
          component: () => import('@/views/dashboard/forms/EntregaLeiteForm'),
        },
        {
          name: 'Contas a Pagar',
          path: '/contas-a-pagar',
          component: () => import('@/views/dashboard/forms/ContasPagarForm'),
        },
        {
          name: 'Contas a Receber',
          path: '/contas-a-receber',
          component: () => import('@/views/dashboard/forms/ContasReceberForm'),
        },
        {
          name: 'Recibo Pgto Leite',
          path: '/recibos-pgto-leite',
          component: () => import('@/views/dashboard/forms/RecibosProdutorForm'),
        },
        {
          name: 'Notas Fiscais',
          path: '/notas-fiscais',
          component: () => import('@/views/dashboard/forms/NotasFiscaisForm'),
        },
        {
          name: 'Declaração de Imp. de Renda',
          path: '/informativo-imposto-renda',
          component: () => import('@/views/dashboard/forms/MovimentacaoLeiteForm'),
        },
        {
          name: 'teste',
          path: '/produtor/teste',
          component: () => import('@/views/dashboard/forms/ValidationForms'),
        },
        {
          name: 'enviaNotif',
          path: '/enviaNotif',
          component: () => import('@/views/dashboard/components/core/Settings'),
        },
        {
          name: 'Aviso',
          path: '/aviso/:idAviso/:produtorId',
          component: () => import('@/views/dashboard/forms/AvisosForm'),
        },
        {
          name: 'Avisos',
          path: '/avisos',
          component: () => import('@/views/dashboard/forms/HistoricoAvisosForm'),
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})
